import { rememberAttribution } from './attribution';

// Loaded by _LayoutFrontend.cshtml on every public page: remember what brought the visitor (see attribution.ts).
rememberAttribution();
